
























































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTODefinition } from '@/scripts/services/ClientApiAuto'
import CFMMultiselect from '@/components/partials/CFMMultiselect.vue'


@Component<PointDefinitionDialog>({
    components: {
        'cfm-multiselect': CFMMultiselect,
    },
    validations() {
        return {
        definition:{
            Name: {required},
        },
        selectedType: {
            PointTypeId: {required}
        },
        }
    },
})
export default class PointDefinitionDialog extends CFMDialog {
    definition: CFMDTODefinition = {Name: ''};
    typeList : {Name:String, Id:Number}[] = [];

    selectedType :CFMDTODefinition = {Name: ''}

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.definition.definitionGetById({id: <number>this.id});
        this.definition = res.data;
      }
      const promises = [
      this.getTypes()
      ];
      if(this.isUpdate){
        if(this.definition && this.definition.PointType){
          this.selectedType = this.definition;
        }
      }
      await Promise.all(promises);
      blockui.unBlockModal();
    }
//TODO ! pointtypegettypes 
    async getTypes(){
      const response = await this.apiClient.common.commonGetPointTypes();
      this.typeList = response.data.map(x=>({Name:<string>x.Text, Id:<number>x.Value}));
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.definition.Id,
        Name: this.definition.Name,
        PointTypeId: this.selectedType.PointTypeId
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.definition.definitionSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
